import { render, staticRenderFns } from "./InviteManager.vue?vue&type=template&id=2059d2ce&"
import script from "./InviteManager.vue?vue&type=script&lang=ts&"
export * from "./InviteManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports